import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Form, FormLayout, Button, Heading } from '@shopify/polaris';
import { BasicTextField } from '@presentational';
import { SellerFormProfile } from '@presentational';
import { tAttribute } from '@utils';

const propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  location: PropTypes.string,
  isSeller: PropTypes.bool,
  values: PropTypes.object.isRequired,
};


const UserSellerForm = ({location, handleChangeSeller, handleChange, handleSubmit, isSeller, values, errors, ...props}) => {
  let sharedFieldProps = {
    handleChange,
    values,
    errors
  }
  return(
      <Form onSubmit={handleSubmit}>
        <FormLayout>
          <hr />
          <BasicTextField
              name="first_name"
              label={ tAttribute("user", "first_name") }
              {...sharedFieldProps}
          />

          <BasicTextField
              name="last_name"
              label={ tAttribute("user", "last_name") }
              {...sharedFieldProps}
          />

          <BasicTextField
              name="email"
              label={tAttribute("user", "email")}
              type="email"
              {...sharedFieldProps}
          />

          <BasicTextField
              name="password"
              label={tAttribute("user", "password")}
              type="password"
              {...sharedFieldProps}
          />

          { isSeller &&
            <SellerFormProfile
                users={ [] }
                locations={ location }
                handleChange={ handleChangeSeller }
                handleSubmit={ handleSubmit }
                values={ values.seller }
                errors={ errors }
                isNested={ true }
            />
          }
          <Button submit loading={ props.loading }>
            { I18n.t("actions.update") }
          </Button>
        </FormLayout>
      </Form>
  )
}



UserSellerForm.propTypes = propTypes;


export default UserSellerForm;

